import { createModel } from '@rematch/core';
import { AlertsInfo, AlertTypeEnum } from 'domains/alertDomain';
import alertService from 'services/alertSerivce';
import type { RootModel } from '.';
import { baseReducers, BaseState } from './baseReducers';

interface AlertState extends BaseState {
  alertsInfo: AlertsInfo;
}

export const alert = createModel<RootModel>()({
  state: {
    alertsInfo: null,
  } as unknown as AlertState,
  reducers: {
    ...baseReducers<AlertState>(),
  },
  effects: (dispatch) => {
    const { alert } = dispatch;

    return {
      async getNotificationAndAlerts(): Promise<void> {
        try {
          const alertsInfo = await alertService.getAlertsInfo();
          alert.setState({
            alertsInfo,
          });
        } catch {}
      },

      async markAlertsTypeAsRead(payload: AlertTypeEnum) {
        // const alertsInfo = await alertService.markAlertsTypeAsRead(payload);
        // alert.setState({
        //   alertsInfo,
        // });
      },
    };
  },
});
